import { List } from '@store/abstract/List';
import { ProductListData } from 'chaika-frontend-types/frontend-cms';

export class ProductList extends List<ProductListData, ProductListData> {
    public getByServiceId(serviceId: string): ProductListData | undefined {
        return this.values.find(it => it.serviceId === serviceId);
    }

    protected create(params: ProductListData): ProductListData {
        return params;
    }
}

export const productList = new ProductList();
